import React, { FC } from 'react'

import { IconName } from 'Components/Icon'
import SidebarNavigation, { NavigationItem } from 'Components/SidebarNavigation/SidebarNavigation'
import { routes } from 'Config/routes'
import { useAppSelector } from 'ReduxStore/hooks'
import { keyCloakUserSelector } from 'ReduxStore/keyCloakUser'

const SettingsSidebar: FC = () => {
  const { accountUrl = '' } = useAppSelector(keyCloakUserSelector)

  const navigationItems: NavigationItem[] = [
    {
      icon: IconName.calendar,
      label: 'Im Tagebuch anzeigen',
      target: routes.settings.index
    },
    {
      icon: IconName.utensils,
      label: 'Menüplan',
      target: routes.settings.menuplan
    },
    {
      icon: IconName.glass,
      label: 'Flüssigkeitszufuhr',
      target: routes.settings.hydration
    },
    {
      icon: IconName.profilepicture,
      label: 'Mein Profilbild',
      target: routes.settings.profilePicture
    },
    {
      icon: IconName.tapeline,
      label: 'Basisdaten ändern',
      target: routes.settings.baseData
    },
    {
      icon: IconName.goal,
      label: 'Mein Programm',
      target: routes.settings.program
    },
    {
      icon: IconName.mail,
      label: 'E-Mail',
      target: accountUrl,
      external: true
    },
    {
      icon: IconName.password,
      label: 'Passwort',
      target: accountUrl.replace('/account', '/account/password'),
      external: true
    }
  ]

  return (
    <div className="col-12 col-lg-4">
      <SidebarNavigation navigationItems={navigationItems} />
    </div>
  )
}

export default SettingsSidebar
